import _ from "lodash";
// Internal
import {
  getRating,
  getShowAsteriskOnRating,
  getUpdatedCriteriaValuesForMypFinalGrade,
} from "../ratingPrimitives";

export const getFinalGradeCriteriaSet = ({
  criteriaSet,
  ratings,
  subjectId,
  gradingPeriodType,
  termId,
  curriculumType,
  shouldNotCalculateFinalGradeFromTotal,
  total,
  isScoreAggregationEnabled,
  isScoreAndGradeAggregationEnabled,
  scoreAggregationConfiguration,
  academicCriteriaSets,
  uid,
  termCriteriaAsteriskMap,
}) => {
  // Get that criteria value

  const academicCriteriaValues = _.get(
    criteriaSet,
    "academicCriteriaValues",
    []
  );

  const updatedAcademicCriteriaValues = getUpdatedCriteriaValuesForMypFinalGrade(
    {
      academicCriteriaSets,
      academicCriteriaValues,
      uid,
    }
  );

  // Calculate final grade from criteria total
  if (!shouldNotCalculateFinalGradeFromTotal) {
    const finalGradeCriteriaSetFromTotal = getFinalGradeFromTotal({
      criteriaSet,
      total,
      updatedAcademicCriteriaValues,
    });

    return finalGradeCriteriaSetFromTotal;
  }
  // Calculate final grade from ratings
  // Get computed rating
  const computedRating = getRating({
    computedRating: true,
    ratings,
    overallGradeSet: criteriaSet,
    subjectId,
    categoryId: null,
    skipIsRemoved: true,
    gradingPeriodType,
    termId,
    curriculumType,
  });

  // Get overriding rating
  const overRidingRating = getRating({
    computedRating: false,
    ratings,
    overallGradeSet: criteriaSet,
    subjectId,
    categoryId: null,
    skipIsRemoved: true,
    gradingPeriodType,
    termId,
    curriculumType,
  });

  const value = _.get(computedRating, "value", "-");
  const valueId = _.get(computedRating, "academicCriteriaValue", "-");

  const overRidingValue = _.get(overRidingRating, "value", null);
  const overRidingRatingId = _.get(overRidingRating, "id", null);
  const overRidingValueId = _.get(
    overRidingRating,
    "academicCriteriaValue",
    null
  );

  // For now score aggregation is enabled in cumulative report section view only
  const showAsteriskOnRating = getShowAsteriskOnRating({
    isScoreAggregationEnabled,
    gradingPeriodType,
    isScoreAndGradeAggregationEnabled,
    scoreAggregationConfiguration,
    subjectId: _.isNil(subjectId) ? "" : subjectId, // In case of IL subjectId is null. The function uses nil values for other operations.
    academicCriteriaSetId: criteriaSet.id,
    academicTermId: termId,
    showAsterisk: _.get(
      termCriteriaAsteriskMap,
      [termId, criteriaSet.criteriaType],
      false
    ),
  });

  return {
    ...criteriaSet,
    value,
    valueId,
    overRidingValue,
    overRidingRatingId,
    overRidingValueId,
    // isRemoved represents isFinalGrade dash
    isRemoved: overRidingRatingId ? _.isNil(overRidingValueId) : valueId == "-",
    showAsteriskOnRating,
    customAcademicCriteriaValues: updatedAcademicCriteriaValues,
  };
};

const getFinalGradeFromTotal = ({
  criteriaSet,
  total,
  updatedAcademicCriteriaValues,
}) => {
  // Calculate final grade based on total
  // If total falls in between of boundary guidelines

  const matchedFinalGradeCriteriaValue = _.find(
    updatedAcademicCriteriaValues,
    value => {
      return _.includes(_.get(value, "boundary_guidelines"), total);
    }
  );
  const { id: valueId, abbreviation } = matchedFinalGradeCriteriaValue || {};

  // if value exists, get abbreviation
  const value = !_.isEmpty(valueId) ? abbreviation : "-";

  return {
    ...criteriaSet,
    value,
    valueId,
    customAcademicCriteriaValues: updatedAcademicCriteriaValues,
  };
};
